//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import Line from './list';
import LineEdit from './edit';

export const FilterLines = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[2] !== "lines") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterLines.Provider value={{ filter, setFilter }}>
      <Route path="/premixlabel/lines" exact component={Line} isPrivate/>
      <Route path="/premixlabel/lines/edit/:id" exact component={LineEdit} isPrivate/>
    </FilterLines.Provider>
  )
}